var DialogReopenMaintenanceModule = /** @class */ (function () {
    function DialogReopenMaintenanceModule() {
    }
    return DialogReopenMaintenanceModule;
}());
export { DialogReopenMaintenanceModule };
